module.exports = (function() { return this["wp"]["editor"]; }());